var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('top-header'),_c('main-menu'),_c('div',{staticClass:"pagecontainer"},[_vm._v("Request Access")]),_c('bottom-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }